var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    _vm._l(_vm.all_coupons, function (coupon) {
      return _c(
        "div",
        { staticClass: "col-12 col-lg-6 mb-4" },
        [
          _c("coupon", {
            attrs: {
              "url-use-coupon": _vm.urlUseCoupon,
              "preset-coupon": coupon,
              "is-vivaincontri": _vm.isVivaincontri,
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }